import { useCallback } from 'react';

import { hexToUint8Array } from '@pactswap/cwap-cm-lib/shared';
import { publicKeyVerify } from 'secp256k1';

/**
 * Returns a stable callback that validates a Coinweb public key string.
 * The key may optionally start with 0x and must lie on the secp256k1 curve.
 */
export const useValidateCoinwebAddress = (): ((keyHex: string) => boolean) => {
  return useCallback((keyHex: string): boolean => {
    if (!keyHex || typeof keyHex !== 'string') {
      return false;
    }

    const strippedKey = keyHex.replace(/^0x/i, '');

    try {
      const keyBytes = hexToUint8Array(strippedKey);
      return publicKeyVerify(keyBytes);
    } catch {
      return false;
    }
  }, []);
};
